"use strict";

var _interopRequireDefault = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shareConfig = void 0;

require("core-js/modules/es6.regexp.split");

var _weixinJsSdk = _interopRequireDefault(require("weixin-js-sdk"));

var _util = require("@/utils/util");

var _index = require("@/api/index");

var jsApiList = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'onMenuShareWeibo', 'updateAppMessageShareData', 'updateTimelineShareData'];

var shareConfig = function shareConfig() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '分享的标题';
  var desc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '分享的描述';
  var imgUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : location.protocol + '//' + process.env.VUE_APP_BASE_API + '/app-client/static/logo.png';

  if (!(0, _util.getIsWxClient)()) {
    return;
  }

  var link = window.location.href.split('#')[0];
  var currentLink = window.location.href;
  (0, _index.getWxSignature)({
    url: link
  }).then(function (response) {
    //   console.log(response)
    var ticket = response.body; // console.log('ticket',ticket)

    _weixinJsSdk.default.config({
      debug: false,
      // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: ticket.appid,
      // 必填，公众号的唯一标识
      timestamp: ticket.timestamp,
      // 必填，生成签名的时间戳
      nonceStr: ticket.nonceStr,
      // 必填，生成签名的随机串
      signature: ticket.signature,
      // 必填，签名
      jsApiList: jsApiList // 必填，需要使用的JS接口列表
      // openTagList: ['wx-open-launch-app'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']

    });

    _weixinJsSdk.default.ready(function () {
      _weixinJsSdk.default.checkJsApi({
        jsApiList: jsApiList,
        // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function success(res) {// console.log(res)
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        }
      }); // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口（即将废弃）


      _weixinJsSdk.default.onMenuShareTimeline({
        title: title,
        // 分享标题
        link: currentLink,
        // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl,
        // 分享图标
        success: function success() {// 用户点击了分享后执行的回调函数
        }
      }); // 获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）


      _weixinJsSdk.default.onMenuShareAppMessage({
        title: title,
        // 分享标题
        desc: desc,
        // 分享描述
        link: currentLink,
        // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl,
        // 分享图标
        type: '',
        // 分享类型,music、video或link，不填默认为link
        dataUrl: '',
        // 如果type是music或video，则要提供数据链接，默认为空
        success: function success() {// 用户点击了分享后执行的回调函数
        }
      }); // 获取“分享到QQ”按钮点击状态及自定义分享内容接口（即将废弃）


      _weixinJsSdk.default.onMenuShareQQ({
        title: title,
        // 分享标题
        desc: desc,
        // 分享描述
        link: currentLink,
        // 分享链接
        imgUrl: imgUrl,
        // 分享图标
        success: function success() {// 用户确认分享后执行的回调函数
        },
        cancel: function cancel() {// 用户取消分享后执行的回调函数
        }
      }); // 获取“分享到QQ空间”按钮点击状态及自定义分享内容接口（即将废弃）


      _weixinJsSdk.default.onMenuShareQZone({
        title: title,
        // 分享标题
        desc: desc,
        // 分享描述
        link: currentLink,
        // 分享链接
        imgUrl: imgUrl,
        // 分享图标
        success: function success() {// 用户确认分享后执行的回调函数
        },
        cancel: function cancel() {// 用户取消分享后执行的回调函数
        }
      }); // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）


      _weixinJsSdk.default.updateAppMessageShareData({
        title: title,
        // 分享标题
        desc: desc,
        // 分享描述
        link: currentLink,
        // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl,
        // 分享图标
        success: function success() {// 设置成功
        }
      }); // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）


      _weixinJsSdk.default.updateTimelineShareData({
        title: title,
        // 分享标题
        link: currentLink,
        // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl,
        // 分享图标
        success: function success() {// 设置成功
        }
      }); // 获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口


      _weixinJsSdk.default.onMenuShareWeibo({
        title: title,
        desc: desc,
        link: currentLink,
        imgUrl: imgUrl,
        trigger: function trigger(res) {// alert('用户点击分享到微博')
        },
        complete: function complete(res) {// alert(JSON.stringify(res))
        },
        success: function success(res) {// alert('已分享')
        },
        cancel: function cancel(res) {// alert('已取消')
        },
        fail: function fail(res) {// alert(JSON.stringify(res))
        }
      });
    });

    _weixinJsSdk.default.error(function (res) {// console.log(res)
    });
  }); // .catch(err => {
  //   console.log(err)
  // })
};

exports.shareConfig = shareConfig;